import type { RotateOpenProps } from '@/animations/rotate-open/rotate-open.types';
import { motion } from 'motion/react';

export default function RotateOpenAnimation(props: RotateOpenProps) {
  const { children, on = false, direction = 'right-down', duration = 0.5, className } = props;

  const fromTo = (): [number, number] => {
    switch (direction) {
      case 'right-down':
        return [180, 90];
      case 'up-down':
        return [180, 0];
    }
  };

  const [from, to] = fromTo();

  return (
    <motion.div
      data-testid='rotate-open-animation'
      className={className}
      animate={{
        rotate: on ? from : to,
      }}
      initial={false}
      transition={{ duration, ease: 'easeInOut' }}
    >
      {children}
    </motion.div>
  );
}
